'use client'

import { Button } from '@mantine/core'
import Link from 'next/link'

// 404 for role-gated routes inside the app shell. notFound() raised from a
// (main) segment (admin/layout.tsx, products/page.tsx) resolves here, and this
// renders within (main)/layout.tsx — which already provides the navbar and
// h-screen shell — so it only fills the content area (no second navbar).
// Unknown URLs are handled by the root not-found.tsx via the [...rest] catch-all.

export default function MainNotFound() {
  return (
    <div className="flex h-full min-h-0 items-center justify-center bg-[#FAF6F2]">
      <div className="flex flex-col items-center text-center">
        <h1 className="font-heading text-6xl font-bold text-[var(--mantine-color-celerityBrand-9)]">
          404
        </h1>
        <p className="mt-3 mb-6 text-lg text-[var(--mantine-color-celerityBrand-9)]">
          The page you are looking for does not exist.
        </p>
        <Link href="/">
          <Button variant="filled">Back to Home</Button>
        </Link>
      </div>
    </div>
  )
}
